export default __webpack_public_path__ + "static/media/generalofthedead.fb83da6f.png";